export default __webpack_public_path__ + "static/media/13-face-with-monocle_1f9d0.77cd0028.png";